import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-amount-cell',
  templateUrl: './amount-cell.component.html',
  styleUrls: ['./amount-cell.component.css']
})
export class AmountCellComponent  {
  private params: any;

  agInit(params: any): void {
    this.params = params;
  }

  getFormatted() {
    return this.params.value;
  }

}
